import { toast } from 'react-toastify';
import { weddingActions } from 'entities/wedding';
import { error, request, socket, success } from 'shared/api';
import { Emits } from 'shared/types';
import { SagaPayload } from 'shared/types/globals';
import { logger, snakeize } from 'shared/utils';
import { put, takeLatest } from 'typed-redux-saga';

export function* selectGodWitnessSaga({ type, payload }: SagaPayload<typeof weddingActions.selectGodWitness>) {
  yield* put(request(type));
  const { godWitnessId } = payload;
  try {
    const data = { emit: Emits.WitnessGodSelect, data: { godWitnessId } };
    socket?.send(JSON.stringify(snakeize(data)));

    yield* put(success(type));
  } catch (err) {
    yield* put(error(type, err));
    toast.error('Something went wrong');
    logger('selectGodWitness', err);
  }
}

export default function* listener() {
  yield takeLatest(weddingActions.selectGodWitness.type, selectGodWitnessSaga);
}
